"use client"

import { useState } from "react"
import { removeItemFromCart } from "src/checkout/hooks/useCart"
import { NpButton } from "src/components/np-design/components/NpButton"
import { BusyIndicator } from "src/components/unstyled/BusyIndicator"
import { StorefrontCartItem } from "src/types/storefront"

export type DeleteButtonProps = {
  item: StorefrontCartItem
}

export const DeleteButton = ({ item }: DeleteButtonProps) => {
  const [disabled, setDisabled] = useState(false)

  return disabled ? (
    <div className="flex size-10 items-center" data-disabled>
      <BusyIndicator />
    </div>
  ) : (
    <NpButton
      size="sm"
      iconNameLeft="delete"
      title="Entfernen"
      variant="ghost"
      color="red"
      disabled={disabled}
      onClick={async () => {
        setDisabled(true)
        await removeItemFromCart(item.key)
        setDisabled(false)
      }}
    />
  )
}
